import BaseModel from "../BaseModel";
import SampleCertTypeTestRequirement from "@/Store/ORM/SampleCertTypeTestRequirement";
import SampleCertTypeCategory from "@/Store/ORM/SampleCertTypeCategory";

export default class SampleCertType extends BaseModel {
    static entity = 'sampleCertTypes';
    static primaryKey = "uuid";

    static fields() {
        return {
            uuid: this.attr(null),
            name: this.attr(null),
            color: this.attr(null),
            billing_category_uuid: this.attr(null),
            billing_category: this.attr(null),
            description: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            category: this.hasOne(SampleCertTypeCategory, 'uuid', 'billing_category_uuid'),
            requirements: this.hasMany(SampleCertTypeTestRequirement, 'sample_cert_type_uuid')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }

    static name(){
        return "SampleProductType"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/sampleCertTypes';
    }
    
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
